import { render, staticRenderFns } from "./HJ0001.vue?vue&type=template&id=022d77ad&scoped=true&"
import script from "./HJ0001.vue?vue&type=script&lang=js&"
export * from "./HJ0001.vue?vue&type=script&lang=js&"
import style0 from "./HJ0001.vue?vue&type=style&index=0&id=022d77ad&prod&lang=less&scoped=true&"
import style1 from "./HJ0001.vue?vue&type=style&index=1&id=022d77ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022d77ad",
  null
  
)

export default component.exports